import { DOCUMENT_TYPES } from '../enums/document.enum';
import { EXAM_SECTIONS } from '../enums/exams.enum';

/** D2 — seeded (all received=false, copiesCount=0) at student_affairs creation time. */
export const DOCUMENT_CHECKLIST = DOCUMENT_TYPES;

/** D-Q7 — configurable installment count, default 4. */
export const DEFAULT_INSTALLMENT_COUNT = 4;

/** D1 §2.3 exam sections seeded (all 'Not Booked') at student registration/conversion.
 * Aliases EXAM_SECTIONS so seeding and enum/validation can never diverge (single source of truth). */
export const EXAM_SECTIONS_SEED = EXAM_SECTIONS;

export const STUDENT_CODE_PATTERN = /^FA-\d{4}-\d{4,}$/;

export const NATIONAL_ID_PATTERN = /^\d{14}$/;
